module.exports = __webpack_public_path__ + "media/site/images/icons/quality-icon-e8c2f520cdafae7916999a01683df929.svg";